import { Box, Typography } from '@mui/material';
import { Rating } from '@care/react-component-lib';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults_caregiver as Caregiver } from '@/__generated__/getSearchResults';

interface CaregiverRatingProps {
  caregiver: Caregiver;
}

const CaregiverRating = ({ caregiver }: CaregiverRatingProps) => {
  const { avgReviewRating, numberOfReviews } = caregiver;

  const ratingFixTo = (rating: number | null) => {
    return rating?.toFixed(1);
  };

  if (numberOfReviews <= 0 || avgReviewRating === null || avgReviewRating <= 0) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-end">
      <Typography
        variant="h1"
        component="span"
        fontSize={{
          md: 'display3.fontSize',
        }}>
        {ratingFixTo(avgReviewRating)}
      </Typography>

      <Box>
        <Rating name="size-medium" size="small" defaultValue={avgReviewRating} readOnly />
        <Typography variant="body2">({numberOfReviews})</Typography>
      </Box>
    </Box>
  );
};

export default CaregiverRating;
